import { useEffect, useState } from "react";
import { getMaquinasJustificadas } from "../services/justificacion";

export const useMaquinasJustificadas = (fecha,id_area_operacion) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);


    useEffect(() => {
        if(!fecha){
            return;
        }
        setLoading(true);
        getMaquinasJustificadas(fecha,id_area_operacion).then(maquinas => {
            setData(maquinas.data)
            setLoading(false);
        })
        .catch(err => {
            setLoading(false);
        });
    }, [fecha,id_area_operacion])



    return { data, loading };
}
